import { render, staticRenderFns } from "./MenuPermissionsTab.vue?vue&type=template&id=644f9112"
import script from "./MenuPermissionsTab.vue?vue&type=script&lang=ts"
export * from "./MenuPermissionsTab.vue?vue&type=script&lang=ts"
import style0 from "./MenuPermissionsTab.vue?vue&type=style&index=0&id=644f9112&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports